import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import womenai1 from './pictures/womenai1.jpg';
import womenai2 from './pictures/womenai2.jpg';
import womenai3 from './pictures/womenai3.jpg';
import womenai4 from './pictures/womenai4.jpg';
import womenai5 from './pictures/womenai5.jpg';

const WomenAI = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Women in AI Collab Event!</h2>
                    <p class="site-post-meta">May 22nd, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC!

                    <br></br>
                    <br></br>

Thank you to everyone who joined us for our recent Women in AI collab event with the AI Student Collective and cseed BuildHer on May 22! ✨💻

<br></br>
<br></br>


The event featured an amazing panel of women working at the forefront of AI across startups and industry in Seattle. We enjoyed hearing the inspiring conversations, career experiences, remarkable insights, and important perspectives that were shared💡

<br></br>
                    <br></br>


Key Takeaways:

<br></br>
                    <br></br>

In the age of AI, if you have an idea, start building! 
Optimize for what you enjoy doing long term
Product + Technical knowledge is important
Always be learning!


<br></br>
                    <br></br>

Big thanks to Cindy Nie, Genia Albre, Anna Fuller, and Nistha Mitra for joining us for an inspiring evening highlighting women in AI! ✨ 

<br></br>
                    <br></br>

                    </p>
                    <img src={womenai1} alt="pic1 "/>
                    <img src={womenai2} alt="pic2 "/>
                    <img src={womenai3} alt="pic3 "/>
                    <img src={womenai4} alt="pic4 "/>
                    <img src={womenai5} alt="pic5 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default WomenAI;
